(ns common.timer)

(defn now
  []
  #?(:cljs (.getTime (js/Date.))
     :clj (System/currentTimeMillis)))

(defn ^:private timer
  ([time-atom]
   (timer time-atom :previous))
  ([time-atom since]
   (let [now (now)
         {:keys [start previous]} @time-atom]
     (swap! time-atom assoc :previous now)
     (if (= since :previous)
       (- now previous)
       (- now start)))))

(defn create-timer
  []
  (let [start-ts (now)
        time-atom (atom {:start    start-ts
                         :previous start-ts})
        timer (partial timer time-atom)]
    timer))


(defn perf-tick
  ([time-atom action]
   (perf-tick time-atom action nil))
  ([time-atom action cb]
   (let [now (now)
         {:keys [start previous reports]} @time-atom]
     (case action
       :reports reports
       :tick (let [tick-report (if (fn? cb)
                                 (cb (- now previous) (- now start))
                                 (str "Perf tick " (- now previous)))]
               (swap! time-atom assoc
                 :previous now
                 :reports (conj reports tick-report))
               tick-report)
       :start (- now start)
       :start-formatted (let [ms (- now start)]
                          (loop [remaining (int (/ ms 1000))
                                 unit "s"]
                            (let [[new-remaining new-unit] (case unit
                                                             "s" [(int (/ remaining 60)) "min"]
                                                             "min" [(int (/ remaining 60)) "h"]
                                                             "h" [(int (/ remaining 24)) "d"]
                                                             "d" [(int (/ remaining 365)) "y"]
                                                             [0 ""])]
                              (if (zero? new-remaining)
                                (str remaining unit)
                                (recur new-remaining new-unit)))))
       (str "Unkonwn action " action)))))

(defn create-perf-timer
  []
  (let [start-ts (now)
        time-atom (atom {:start    start-ts
                         :previous start-ts
                         :reports  []})
        cb (partial perf-tick time-atom)]
    cb))
